export const Loading = () => {
  return (
    <button className="bg-[#FCF82A] text-[#012D4A] text-base rounded-[4px] px-8 py-4 uppercase font-bold pointer-events-none">CARREGANDO...</button>

  );
};
